import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const endorsementLibrariesRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('endorsement-libraries', {
      create: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Create.vue'),
      edit: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Edit.vue'),
      show: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/Show.vue'),
      list: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/List.vue'),
    })
      .permissions({
        create: 'endorsement-libraries.create',
        edit: 'endorsement-libraries.update',
        show: 'endorsement-libraries.view',
        list: 'endorsement-libraries.view',
      })
      .meta({
        create: { back: 'endorsement-libraries.list' },
        edit: { back: 'endorsement-libraries.list' },
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
